/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-filter-footer',
    templateUrl: './filter-footer.component.html',
    styleUrls: ['./filter-footer.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterFooterComponent  {
    @Input() filterName: string;
    @Output() applyClick = new EventEmitter<void>();
    @Output() clearClick = new EventEmitter<void>();
}
